<template>
  <div class="device-img">
    <machine21082C class="qsw-2108-2c" width="100%" height="90" v-if="(systemHostInfo && systemHostInfo.Product === 'QSW-M2108-2C')" />
    <machine21082C class="qsw-2108-2c" width="100%" height="90" v-else-if="(systemHostInfo && systemHostInfo.Product === 'QSW-M2108R-2C')" />
    <machine21082S class="qsw-2108-2s" width="100%" height="90" v-else-if="(systemHostInfo && systemHostInfo.Product === 'QSW-M2108-2S')" />
    <machine12008C class="qsw-1200-8c" width="100%" height="80" v-else-if="(systemHostInfo && systemHostInfo.Product === 'QSW-IM1200-8C')" />
    <machine52161t class="qsw-5216-1t" width="100%" height="80" v-else-if="(systemHostInfo && systemHostInfo.Product === 'QSW-M5216-1T')" />
    <machine1204back class='qsw-120x-back back' width="100%" height="80" v-else-if="(systemHostInfo && systemHostInfo.Product.includes('1204') && back)" />
    <machine1204 class='qsw-120x' width="100%" height="80" v-else-if="(systemHostInfo && systemHostInfo.Product.includes('1204'))" />
    <machine1208back class='qsw-120x-back back' width="100%" height="80" v-else-if="(systemHostInfo && systemHostInfo.Product.includes('1208') && back)" />
    <machine1208 class='qsw-120x' width="100%" height="80" v-else-if="(systemHostInfo && systemHostInfo.Product.includes('1208'))" />
    <machine804back class='qsw-804-back back' width="100%" height="80" v-else-if="(systemHostInfo && systemHostInfo.Product.includes('804') && back)" />
    <machine804 class='qsw-804' width="100%" height="80" v-else-if="(systemHostInfo && systemHostInfo.Product.includes('804'))" />
    <machine2C class="qsw-408" width="100%" height="80" v-else-if="(systemHostInfo && systemHostInfo.Product === 'QSW-M408-2C')" />
    <machine4C class="qsw-408" width="100%" height="80" v-else-if="(systemHostInfo && systemHostInfo.Product === 'QSW-M408-4C')" />
    <machine21064C class="qsw-2106" width="100%" height="80" v-else-if="(systemHostInfo && systemHostInfo.Product === 'QSW-M2106-4C')" />
    <machine21064S class="qsw-2106" width="100%" height="80" v-else-if="(systemHostInfo && systemHostInfo.Product === 'QSW-M2106-4S')" />
    <machine2106PR2S2T class="qsw-2106" width="100%" height="80" v-else-if="(systemHostInfo && systemHostInfo.Product === 'QSW-M2106PR-2S2T')" />
    <machineS class="qsw-408" width="100%" height="80" v-else />
  </div>
</template>

<script>
import machine1204 from '../../assets/svg/machine_1204.svg'
import machine1208 from '../../assets/svg/machine_1208.svg'
import machine804 from '../../assets/svg/machine_804.svg'
import machine2C from '../../assets/svg/machine_2c.svg'
import machine4C from '../../assets/svg/machine_4c.svg'
import machineS from '../../assets/svg/machine_s.svg'
import machine21082C from '../../assets/svg/machine_2108_2c.svg'
import machine21082S from '../../assets/svg/machine_2108_2s.svg'
import machine12008C from '../../assets/svg/machine_1200_8c.svg'
import machine52161t from '../../assets/svg/machine_5216_1t.svg'
import machine1204back from '../../assets/svg/machine_1204_back.svg'
import machine1208back from '../../assets/svg/machine_1208_back.svg'
import machine804back from '../../assets/svg/machine_804_back.svg'
import machine21064C from '../../assets/svg/machine_2106_4c.svg'
import machine21064S from '../../assets/svg/machine_2106_4s.svg'
import machine2106PR2S2T from '../../assets/svg/machine_2106pr_2s2t.svg'
import { mapState } from 'vuex'
export default {
  name: 'machine',
  props: ['back'],
  components: {
    machine21082C,
    machine21082S,
    machine12008C,
    machine1204,
    machine1208,
    machine804,
    machine2C,
    machine4C,
    machineS,
    machine52161t,
    machine1208back,
    machine1204back,
    machine804back,
    machine21064C,
    machine21064S,
    machine2106PR2S2T
  },
  computed: {
    ...mapState({
      systemHostInfo: state => state.module.systemHostInfo,
      fwinfo: state => state.module.fwinfo
    })
  }
}
</script>

<style lang="scss" scoped>
svg {
  // height: 80px;
  width: 100%;
  .shape {
    fill: none;
    stroke: #2f2f2f;
    stroke-width: 1;
    stroke-miterlimit: 10;
  }
  .lcd {
    fill: #ccc;
    stroke: none;
    stroke-width: 0.3019;
    stroke-miterlimit: 10;
  }
  .circle {
    fill: #3b415f;
  }
  .border {
    fill: none;
    stroke: #2f2f2f;
    stroke-width: 0.6;
    stroke-miterlimit: 10;
  }
  .unconnected {
    fill: #dbdddd;
  }
  .hide {
    fill: none;
  }
  .symbol_flash {
    fill: #2f2f2f;
  }
  .symbol_enable {
    fill: none;
    stroke: #ffffff;
    stroke-width: 0.75;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
  }
  .symbol_disable {
    fill: none;
    stroke: #ffffff;
    stroke-width: 0.75;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
  }
  .circle_flash {
    fill: rgba(255, 255, 255, 0.6);
    stroke: #000000;
    stroke-width: 0.25;
    stroke-miterlimit: 10;
  }
  .st0 {
    fill: #ffffff;
  }
  .st1 {
    font-family: "ArialMT";
  }
  .st2 {
    font-size: 8px;
  }
  .st3 {
    font-size: 4px;
  }
  .st4 {
  font-size: 8px;
  }
  [id^="tooltip_"],
  [id*=" tooltip_"] {
    visibility: hidden;
  }
}

svg.qsw-2108-2c, svg.qsw-2108-2s, svg.qsw-120x, svg.qsw-408, svg.qsw-1200-8c, svg.qsw-804, svg.qsw-5216-1t, svg.qsw-2106{
  height:110px;
  .st2 {
    font-size: 4px;
  }
  .st3 {
    font-size: 6px;
  }
  .st4 {
    font-size: 8px;
  }
}

svg.qsw-120x-back {
  .others {
    fill: none;
    stroke: #2f2f2f;
    stroke-width:0.25;
    stroke-miterlimit:10
  }
}

.enterprise {
  svg {
    .shape {
      fill: none;
      stroke: #2f2f2f;
      stroke-width: 1;
      stroke-miterlimit: 10;
    }
    .logo {
      fill: black;
      stroke: none;
      stroke-width: 0.3019;
      stroke-miterlimit: 10;
    }
    .lcd {
      fill: #ccc;
      stroke: none;
      stroke-width: 0.3019;
      stroke-miterlimit: 10;
    }
    .circle {
      fill: #3b415f;
    }
    .border {
      fill: none;
      stroke: #2f2f2f;
      stroke-width: 0.6;
      stroke-miterlimit: 10;
    }
    .unconnected {
      fill: #dbdddd;
    }
    .hide {
      fill: none;
    }
    .symbol_flash {
      fill: #2f2f2f;
    }
    .symbol_enable {
      fill: none;
      stroke: #ffffff;
      stroke-width: 0.75;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-miterlimit: 10;
    }
    .symbol_disable {
      fill: none;
      stroke: #ffffff;
      stroke-width: 0.75;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-miterlimit: 10;
    }
    .circle_flash {
      fill: rgba(255, 255, 255, 0.6);
      stroke: #000000;
      stroke-width: 0.25;
      stroke-miterlimit: 10;
    }
    .st0 {
      fill: #ffffff;
    }
    .st1 {
      font-family: "ArialMT";
    }
    .st2 {
      font-size: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/Machine.vue